// DS: CO0.1M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Sticky from '../../../Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
const DeviationPageHeader = ()=>{
    const isMobile = useContext(MobileContext);
    const { isInDuperbrowse } = useDuperbrowseViewType();
    const { adsEnabled } = useContext(SessionContext);
    if (!isMobile) {
        return /*#__PURE__*/ React.createElement(SiteHeader, null);
    }
    if (isInDuperbrowse || adsEnabled) {
        return /*#__PURE__*/ React.createElement(Sticky, {
            marginTop: -1
        }, (isStuck)=>/*#__PURE__*/ React.createElement(MobileSubmissionDetailsHeader, {
                isSticky: true,
                isStuck: isStuck
            }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SiteHeader, null), /*#__PURE__*/ React.createElement(MobileSubmissionDetailsHeader, {
        isSticky: false
    }));
};
DeviationPageHeader.displayName = 'DeviationPageHeader';
export default DeviationPageHeader;
